module.exports = function anonymous(it
/**/) {
var encodeHTML = typeof _encodeHTML !== 'undefined' ? _encodeHTML : (function (doNotSkipEncoded) {
		var encodeHTMLRules = { "&": "&#38;", "<": "&#60;", ">": "&#62;", '"': "&#34;", "'": "&#39;", "/": "&#47;" },
			matchHTML = doNotSkipEncoded ? /[&<>"'\/]/g : /&(?!#?\w+;)|<|>|"|'|\//g;
		return function(code) {
			return code ? code.toString().replace(matchHTML, function(m) {return encodeHTMLRules[m] || m;}) : "";
		};
	}());var out='<div class="cols-l-6 cols-xxl-3 filter-fadein"> <a href="#" class="gallery-item';if(it.Video){out+=' gallery-item--video';}out+=' equal is-disabled" data-widget="GalleryItem"';if(it.Image){out+=' data-image=\''+(JSON.stringify(it.Image))+'\'';}if(it.Video){out+=' data-video=\''+(JSON.stringify(it.Video))+'\'';}out+=' data-caption="'+encodeHTML(it.Caption)+'"> <figure> <img src="'+encodeHTML(it.Thumb)+'" alt="'+encodeHTML(it.Caption)+'"> <figcaption class="gallery-item__caption">'+encodeHTML(it.Caption)+'</figcaption> </figure> </a></div>';return out;
}


//////////////////
// WEBPACK FOOTER
// ./source/scripts/templates/filters/gallery.dot
// module id = 258
// module chunks = 0 1